import { Diagram } from 'gojs';
import { GoJsModelProperties } from '../configs';

export const hasDiagramDarkMode = (diagram: Diagram | null) =>
  diagram?.model.modelData[GoJsModelProperties.HasDarkMode];
